module.exports = __webpack_public_path__ + "assets/img/dc07737d98cc53bec046a8f9eddfa36f.png";